import React, { useEffect, useState } from 'react';
import {
  Card,
  Col,
  Row,
  Table,
  VertButton,
  Typography,
} from '@vertem-core/vertice-ds';
import { DeleteFilled, EditFilled } from '@ant-design/icons';
import ValuePriceForPoint from 'pages/newSolicitation/components/ValuePriceForPoint';
import { useMediaQuery } from 'react-responsive';

import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import ModalProduct from '../Modals/ModalProduct';
import { useDispatch } from 'react-redux';
import { loadRedemptionCategories } from 'redux/Reducers/Spot/spotNewSolicitationSlice';

const initialValueProducts = {
  name: '',
  quantity: '',
  unitPrice: '',
  description: '',
  points: '',
};

const SpotTableAndProducts = ({
  products,
  setProducts,
  config,
  cotacaoPremmiar,
  tipoSolicitacaoWatch,
}) => {
  const [isModalCreateProduct, setIsModalCreateProduct] = useState(false);
  const [isModalEditProduct, setIsModalEditProduct] = useState(false);
  const [initialValueProduct, setInitialValueProduct] =
    useState(initialValueProducts);
  const dispatch = useDispatch();
  const { isPMO } = useParticipantSubSegment();

  const mediaQuery = useMediaQuery({ query: '(max-width: 768px)' });

  const handleAddProduct = (product) => {
    setProducts([...products, product]);
    setIsModalCreateProduct(false);
  };

  const handleUpdateProduct = (updatedProduct) => {
    const index = products.findIndex(
      (product) => product.id === updatedProduct.id
    );

    if (index !== -1) {
      const updatedProducts = [...products];
      updatedProducts[index] = updatedProduct;
      setProducts(updatedProducts);
    }

    setIsModalEditProduct(false);
  };

  const handleRemoveProduct = (product) => {
    const newProducts = products.filter((p) => p.id !== product.id);
    setProducts(newProducts);
  };

  const handleEditProduct = (product) => {
    const customProducts = {
      id: product.id,
      name: product.name,
      unitPrice: product.unitPrice,
      points: product.unitPointsPrice,
      quantity: String(product.quantity),
      description: product.description,
      categorias: product.categorias,
      subCategorias: product.subCategorias,
    };

    setInitialValueProduct(customProducts);
    setIsModalEditProduct(true);
  };

  useEffect(() => {
    dispatch(loadRedemptionCategories());
  }, []);

  const premmiarQuote = !cotacaoPremmiar;
  const solicitationType = tipoSolicitacaoWatch.value !== '1';
  const shouldBeHiddenCategories = premmiarQuote && isPMO && solicitationType;

  const columns = [
    {
      title: 'Produto',
      dataIndex: 'name',
      key: 'name',
      render: (_, { name }) => <Typography.Text>{name}</Typography.Text>,
      width: '25%',
    },

    {
      title: 'Categoria',
      dataIndex: 'categoryName',
      key: 'categoryName',
      render: (_, { categoryName, subCategoryName }) => {
        if (!categoryName) {
          return (
            <div className="vert-product-table-spot-value">
              <Typography.Text> - </Typography.Text>
              <p
                style={{
                  fontSize: mediaQuery ? '12px' : '14px',
                  fontStyle: 'italic',
                  color: 'var(--color-error)',
                }}
              >
                *Categoria é obrigatória
              </p>
            </div>
          );
        }

        return (
          <div className="vert-product-table-spot-value">
            <Typography.Text>{categoryName}</Typography.Text>
            <Typography.Text>({subCategoryName})</Typography.Text>
          </div>
        );
      },
      width: '25%',
      hidden: !shouldBeHiddenCategories,
    },
    {
      title: mediaQuery ? 'Qtd' : 'Quantidade',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (_, { quantity }) => (
        <Typography.Text>{quantity}</Typography.Text>
      ),
      width: '15%',
    },

    {
      title: 'Valor em Reais',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      width: '15%',
      render: (_, { unitPrice }) => (
        <div className="vert-product-table-spot-value">
          <Typography.Text
            style={{
              fontSize: mediaQuery ? '12px' : '14px',
              color: 'var(--color-gray)',
            }}
          >
            {new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(unitPrice)}
          </Typography.Text>
        </div>
      ),
    },

    {
      title: 'Total em Reais',
      dataIndex: 'total',
      key: 'total',
      width: '15%',
      render: (_, { unitPrice, quantity }) => (
        <div className="vert-product-table-spot-value">
          <Typography.Text
            style={{
              fontSize: mediaQuery ? '12px' : '14px',
              fontWeight: 'bold',
            }}
          >
            {new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(unitPrice * quantity)}
          </Typography.Text>
          <ValuePriceForPoint price={unitPrice * quantity} />
        </div>
      ),
    },

    {
      title: mediaQuery ? '' : 'Ações',
      dataIndex: 'acoes',
      key: 'acoes',
      width: '5%',
      render: (_, payload) => (
        <div className="vert-product-table-spot">
          <VertButton
            type="highlight"
            shape={'round'}
            icon={<EditFilled />}
            size={'small'}
            onClick={() => {
              handleEditProduct(payload);
            }}
          />
          <VertButton
            type="default"
            shape="round"
            icon={<DeleteFilled />}
            size={'small'}
            onClick={() => {
              handleRemoveProduct(payload);
            }}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <Col xs={24} sm={24}>
        <Row
          gutter={[16, 16]}
          justify="space-between"
          wrap
          verticalSpacing="regular"
        >
          <div />

          <VertButton
            onClick={() => {
              setIsModalCreateProduct(true);
            }}
            shape="default"
          >
            Adicionar Produto
          </VertButton>
        </Row>
      </Col>

      {products.length > 0 ? (
        <>
          <Table
            columns={columns}
            dataSource={products}
            pagination={false}
            bordered
            tableLayout="auto"
            sticky
            size={'small'}
            locale={{
              emptyText: 'Nenhum produto adicionado',
            }}
            scroll={{ x: 1000 }}
          />
          <div className="card-total-edit-redemption">
            <div>
              <Typography.Text className="vert-product-table-spot-value title-spot-typograph">
                Valor total
              </Typography.Text>
            </div>
            <div className="vert-total-value-spot-typograph">
              <Typography.Text className="title-spot-typograph">
                {new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(
                  products.reduce(
                    (acc, product) =>
                      acc + product.unitPrice * product.quantity,
                    0
                  )
                )}
              </Typography.Text>
              <ValuePriceForPoint
                price={products.reduce(
                  (acc, product) => acc + product.unitPrice * product.quantity,
                  0
                )}
              />
            </div>
          </div>
        </>
      ) : (
        <Card className="card-alert-error">
          <Typography.Text className="alert-error-spot-redemption">
            Por favor, adicione ao menos 1 (um) produto para dar continuidade à
            solicitação.
          </Typography.Text>
        </Card>
      )}
      <ModalProduct
        showOpen={isModalCreateProduct}
        closeModal={() => setIsModalCreateProduct(false)}
        handleCreateProduct={handleAddProduct}
        initialValues={initialValueProducts}
        isEditModal={false}
        cotacaoPremmiar={cotacaoPremmiar}
      />
      <ModalProduct
        showOpen={isModalEditProduct}
        closeModal={() => {
          setIsModalEditProduct(false);
          setInitialValueProduct(initialValueProducts);
        }}
        handleCreateProduct={handleUpdateProduct}
        initialValues={initialValueProduct}
        isEditModal
        cotacaoPremmiar={cotacaoPremmiar}
      />
    </>
  );
};

export default SpotTableAndProducts;
